import React, { Suspense } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Tabs, Tab, Button } from "react-bootstrap";
import ServiceInvoicesList from "./list-service-invoices";
import ClientInvoicesList from "./list-client-export";
import {
    exportAccountingActiveJobs,
    fetchAccountingServiceInvoicesBatches,
    fetchAccountingClientInvoicesBatches
} from "../../../../api/menu/invoicing/actions";
import saveByDialog from "../../../../helpers/save-by-dialog";
import { closeCustomModal, openCustomModal } from "../../../custom/modals";

class AccountingExportList extends React.Component {
    tabs = {
        serviceInvoices: "serviceInvoices",
        clientInvoices: "clientInvoices"
    };

    constructor(props) {
        super(props);

        this.handleLoadServiceInvoices = this.handleLoadServiceInvoices.bind(this);
    }

    componentDidMount() {
        this.handleLoadServiceInvoices();
    }

    handleLoadServiceInvoices() {
        this.props.fetchAccountingServiceInvoicesBatches();
        this.props.fetchAccountingClientInvoicesBatches();
    }

    render() {
        return (
            <div>
                <h3 className="mb-4">
                    Export for Accounting
                </h3>
                <Button
                    variant="warning"
                    className="mb-2"
                    onClick={() => this.props.exportAccountingActiveJobs()}
                >
                    Export Active Jobs
                </Button>
                <Tabs
                    id="accounting-tabs"
                    defaultActiveKey={this.tabs.serviceInvoices}
                    className="w-100"
                    mountOnEnter={true}
                    unmountOnExit={true}
                >
                    <Tab
                        eventKey={this.tabs.serviceInvoices}
                        title="Service Invoices"
                    >
                        <ServiceInvoicesList batches={this.props.batchServices}/>
                    </Tab>
                    <Tab
                        eventKey={this.tabs.clientInvoices}
                        title="Client Invoices"
                    >
                        <ClientInvoicesList batches={this.props.batchClients}/>
                    </Tab>
                </Tabs>
            </div>
        );
    }
}
const mapStateToProps = state => ({
    batchServices: state.invoicing.batchServices,
    batchClients: state.invoicing.batchClients,
});

const mapStateToDispatch = dispatch => ({
    exportAccountingActiveJobs: bindActionCreators(exportAccountingActiveJobs, dispatch),
    fetchAccountingServiceInvoicesBatches:
        bindActionCreators(fetchAccountingServiceInvoicesBatches, dispatch),
    fetchAccountingClientInvoicesBatches:
        bindActionCreators(fetchAccountingClientInvoicesBatches, dispatch),
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(AccountingExportList);
